// Real project photos migrated from the client's existing site (self-hosted).
// Each image has unique, keyword-rich alt text for SEO + accessibility.
const BASE = "/images/work";

export const GALLERY = [
  {
    src: `${BASE}/modern-residential-garage-door-prosper-tx.jpg`,
    alt: "Modern residential garage door installed and repaired in Prosper, TX",
    caption: "Residential garage door repair",
    span: "wide",
  },
  {
    src: `${BASE}/custom-wood-carriage-garage-doors-prosper-tx.jpg`,
    alt: "Custom wood-grain carriage style garage doors on a brick home in Prosper, TX",
    caption: "Custom carriage-style doors",
  },
  {
    src: `${BASE}/new-garage-door-installation-prosper-tx.jpg`,
    alt: "New garage door installation completed in Prosper, TX",
    caption: "New door installation",
  },
  {
    src: `${BASE}/garage-door-opener-installation-prosper-tx.jpg`,
    alt: "Garage door opener repair and installation in Prosper, TX",
    caption: "Opener repair & install",
  },
  {
    src: `${BASE}/commercial-garage-door-repair-prosper-tx.jpg`,
    alt: "Commercial overhead garage door repair for a business in Collin County, TX",
    caption: "Commercial garage doors",
  },
  {
    src: `${BASE}/storm-rated-garage-door-prosper-tx.jpg`,
    alt: "Storm and tornado rated reinforced garage door installed in Prosper, TX",
    caption: "Storm-rated doors",
  },
  {
    src: `${BASE}/garage-door-installation-collin-county-tx.jpg`,
    alt: "Garage door installation and replacement project in Collin County, TX",
    caption: "Garage door replacement",
    span: "wide",
  },
  {
    src: `${BASE}/residential-garage-door-replacement-prosper-tx.jpg`,
    alt: "Residential garage door replacement with new panels in Prosper, TX",
    caption: "Panel & door replacement",
  },
  {
    src: `${BASE}/insulated-steel-garage-door-prosper-tx.jpg`,
    alt: "Insulated steel garage door installed on a Prosper, TX home",
    caption: "Insulated steel doors",
    span: "tall",
  },
  {
    src: `${BASE}/carriage-style-garage-door-prosper-tx.jpg`,
    alt: "Carriage style garage door with decorative hardware in Prosper, TX",
    caption: "Carriage-style upgrade",
    span: "tall",
  },
];

// Photo paired with each homepage/city service card (by service title).
export const SERVICE_IMAGES = {
  "Garage Door Spring Repair": {
    src: `${BASE}/modern-residential-garage-door-prosper-tx.jpg`,
    alt: "Garage door with broken torsion spring repaired in Prosper, TX",
  },
  "Garage Door Opener Repair": {
    src: `${BASE}/garage-door-opener-installation-prosper-tx.jpg`,
    alt: "Garage door opener repair and installation in Prosper, TX",
  },
  "Off-Track Garage Door Repair": {
    src: `${BASE}/residential-garage-door-replacement-prosper-tx.jpg`,
    alt: "Off-track garage door realigned and repaired in Prosper, TX",
  },
  "Garage Door Panel Replacement": {
    src: `${BASE}/custom-wood-carriage-garage-doors-prosper-tx.jpg`,
    alt: "Garage door panel replacement on a Prosper, TX home",
  },
  "New Garage Door Installation": {
    src: `${BASE}/new-garage-door-installation-prosper-tx.jpg`,
    alt: "New garage door installation completed in Prosper, TX",
  },
  "24/7 Emergency Garage Door Repair": {
    src: `${BASE}/commercial-garage-door-repair-prosper-tx.jpg`,
    alt: "24/7 emergency garage door repair in Prosper and Collin County, TX",
  },
  "Garage Door Won't Close Repair": {
    src: `${BASE}/modern-farmhouse-two-car-garage-door-tx.jpg`,
    alt: "Garage door that won't close — safety sensor and limit repair in Prosper, TX",
  },
  "Garage Door Cable Repair & Replacement": {
    src: `${BASE}/garage-door-spring-repair-technician-tx.jpg`,
    alt: "Garage door lift cable repair and replacement in Prosper, TX",
  },
  "Garage Door Roller Replacement": {
    src: `${BASE}/three-car-garage-doors-collin-county-tx.jpg`,
    alt: "Garage door roller replacement for quiet operation in Prosper, TX",
  },
  "Garage Door Remote & Keypad Programming": {
    src: `${BASE}/smart-garage-door-opener-installation-tx.jpg`,
    alt: "Garage door remote and keypad programming in Prosper, TX",
  },
};

// Master photo pool (real client photos + AI-generated variety) used to build
// a UNIQUE, city-specific gallery on each geo page so no two pages look alike.
const POOL = {
  r_modern: { f: "modern-residential-garage-door-prosper-tx.jpg", d: "Residential garage door repair", c: "Residential repair" },
  r_carriage: { f: "custom-wood-carriage-garage-doors-prosper-tx.jpg", d: "Custom wood carriage-style garage doors", c: "Custom carriage doors" },
  r_install: { f: "new-garage-door-installation-prosper-tx.jpg", d: "New garage door installation", c: "New installation" },
  r_opener: { f: "garage-door-opener-installation-prosper-tx.jpg", d: "Garage door opener repair and installation", c: "Opener repair & install" },
  r_commercial: { f: "commercial-garage-door-repair-prosper-tx.jpg", d: "Commercial overhead garage door repair", c: "Commercial doors" },
  r_storm: { f: "storm-rated-garage-door-prosper-tx.jpg", d: "Storm and tornado-rated garage door", c: "Storm-rated doors" },
  r_replace1: { f: "garage-door-installation-collin-county-tx.jpg", d: "Garage door installation and replacement", c: "Door replacement" },
  r_replace2: { f: "residential-garage-door-replacement-prosper-tx.jpg", d: "Residential garage door panel replacement", c: "Panel replacement" },
  r_insulated: { f: "insulated-steel-garage-door-prosper-tx.jpg", d: "Insulated steel garage door", c: "Insulated steel doors" },
  r_carriage2: { f: "carriage-style-garage-door-prosper-tx.jpg", d: "Carriage-style garage door upgrade", c: "Carriage-style upgrade" },
  a_farmhouse: { f: "white-carriage-garage-door-farmhouse-tx.jpg", d: "White carriage-style garage door on a modern farmhouse", c: "Farmhouse carriage door" },
  a_glass: { f: "modern-glass-aluminum-garage-door-tx.jpg", d: "Modern glass and aluminum garage door", c: "Glass & aluminum door" },
  a_panel_tech: { f: "garage-door-panel-installation-technician-tx.jpg", d: "Technician installing a garage door panel", c: "Panel installation" },
  a_opener_unit: { f: "smart-garage-door-opener-installation-tx.jpg", d: "Smart Wi-Fi garage door opener installation", c: "Smart opener install" },
  a_black: { f: "black-modern-farmhouse-garage-door-tx.jpg", d: "Black modern farmhouse garage door", c: "Black modern door" },
  a_spring_tech: { f: "garage-door-spring-repair-technician-tx.jpg", d: "Technician repairing a garage door torsion spring", c: "Spring repair" },
  a_woodstone: { f: "wood-look-garage-door-stone-home-tx.jpg", d: "Wood-look garage door on a stone home", c: "Wood-look door" },
  a_threecar: { f: "three-car-garage-doors-collin-county-tx.jpg", d: "Three-car garage with insulated steel doors", c: "Three-car garage" },
  a_farmhouse2: { f: "modern-farmhouse-two-car-garage-door-tx.jpg", d: "Two-car garage door on a modern farmhouse", c: "Two-car farmhouse" },
};

// Distinct 6-photo mix per city (real + AI), each in a unique order.
const CITY_IMAGE_SETS = {
  prosper: ["r_modern", "r_install", "r_carriage", "a_spring_tech", "r_storm", "a_opener_unit"],
  celina: ["a_farmhouse", "r_carriage2", "a_threecar", "r_install", "a_opener_unit", "r_insulated"],
  frisco: ["a_glass", "a_black", "r_modern", "a_opener_unit", "r_opener", "a_threecar"],
  aubrey: ["a_woodstone", "r_carriage", "a_farmhouse2", "r_insulated", "a_panel_tech", "r_install"],
  mckinney: ["a_black", "r_carriage", "a_farmhouse", "r_modern", "a_spring_tech", "r_replace2"],
  melissa: ["r_insulated", "a_farmhouse2", "r_install", "a_threecar", "r_storm", "a_opener_unit"],
  anna: ["a_threecar", "r_replace1", "a_panel_tech", "r_replace2", "a_woodstone", "r_opener"],
  allen: ["r_modern", "a_threecar", "r_opener", "a_black", "r_install", "a_opener_unit"],
  plano: ["a_glass", "r_modern", "a_black", "r_carriage", "a_opener_unit", "r_replace2"],
  wylie: ["a_farmhouse", "r_storm", "a_threecar", "r_install", "a_woodstone", "r_opener"],
  murphy: ["r_insulated", "a_farmhouse2", "r_modern", "a_opener_unit", "r_carriage2", "a_panel_tech"],
  sachse: ["a_farmhouse2", "r_install", "a_opener_unit", "r_insulated", "a_threecar", "r_modern"],
  parker: ["r_carriage", "a_woodstone", "r_storm", "a_black", "r_carriage2", "a_threecar"],
  lucas: ["a_woodstone", "r_carriage", "a_threecar", "r_storm", "r_install", "a_spring_tech"],
  fairview: ["a_black", "r_carriage2", "a_farmhouse", "r_modern", "a_opener_unit", "r_insulated"],
  princeton: ["r_insulated", "a_threecar", "r_install", "a_opener_unit", "r_replace2", "a_panel_tech"],
  lavon: ["a_farmhouse", "r_storm", "a_threecar", "r_opener", "a_woodstone", "r_insulated"],
  nevada: ["r_carriage", "a_woodstone", "r_commercial", "a_spring_tech", "r_storm", "a_threecar"],
  josephine: ["r_insulated", "a_farmhouse2", "r_install", "a_opener_unit", "a_panel_tech", "r_modern"],
  farmersville: ["r_carriage", "a_woodstone", "r_modern", "a_farmhouse", "r_replace2", "a_spring_tech"],
  "lowry-crossing": ["a_woodstone", "r_carriage", "r_storm", "a_threecar", "a_panel_tech", "r_install"],
  "new-hope": ["r_carriage", "a_woodstone", "a_threecar", "r_storm", "r_commercial", "a_spring_tech"],
  "st-paul": ["a_farmhouse", "r_storm", "a_threecar", "r_install", "r_opener", "a_woodstone"],
  weston: ["r_carriage", "a_woodstone", "r_commercial", "a_threecar", "r_storm", "a_panel_tech"],
  "blue-ridge": ["r_modern", "a_farmhouse", "r_carriage", "a_spring_tech", "r_install", "a_opener_unit"],
  "little-elm": ["a_farmhouse", "r_storm", "a_threecar", "r_install", "a_woodstone", "r_opener"],
  "the-colony": ["a_glass", "a_black", "r_modern", "a_threecar", "r_opener", "a_opener_unit"],
  lewisville: ["r_modern", "a_black", "r_replace2", "a_opener_unit", "r_carriage", "a_panel_tech"],
  carrollton: ["r_carriage", "a_farmhouse", "r_modern", "a_spring_tech", "r_replace1", "a_opener_unit"],
  richardson: ["a_glass", "r_modern", "a_black", "r_opener", "a_panel_tech", "r_replace2"],
  denton: ["r_carriage", "a_woodstone", "r_modern", "a_farmhouse", "r_install", "a_spring_tech"],
  "collin-county": ["a_glass", "a_threecar", "r_commercial", "a_black", "r_modern", "a_panel_tech"],
};

export const cityGallery = (slug, cityName) => {
  const keys = CITY_IMAGE_SETS[slug] || CITY_IMAGE_SETS["collin-county"];
  return keys.map((k, i) => {
    const p = POOL[k];
    return {
      src: `${BASE}/${p.f}`,
      alt: `${p.d} in ${cityName}, TX`,
      caption: p.c,
      span: i === 0 ? "wide" : i === 3 ? "tall" : undefined,
    };
  });
};
